module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-horizontal"
  }, [_c('fieldset', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "for": "radios"
    }
  }, [_vm._v("Hauptkontakt")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "radio-inline",
    attrs: {
      "for": "radios-0"
    }
  }, [_c('input', {
    attrs: {
      "name": "radios",
      "id": "radios-0",
      "value": "true",
      "type": "radio"
    },
    domProps: {
      "checked": _vm.model.model.is_main
    },
    on: {
      "click": function($event) {
        _vm.model.model.is_main = true
      }
    }
  }), _vm._v("\n\t\t\t\t\tJa\n\t\t\t\t")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline",
    attrs: {
      "for": "radios-1"
    }
  }, [_c('input', {
    attrs: {
      "name": "radios",
      "id": "radios-1",
      "value": "false",
      "type": "radio"
    },
    domProps: {
      "checked": !_vm.model.model.is_main
    },
    on: {
      "click": function($event) {
        _vm.model.model.is_main = false
      }
    }
  }), _vm._v("\n\t\t\t\t\tNein\n\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "for": "selectbasic"
    }
  }, [_vm._v("Art")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.mode),
      expression: "model.model.mode"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "contact_list"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.model.model.mode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.$store.getters.models('contact_types')), function(contacttype) {
    return _c('option', {
      domProps: {
        "value": contacttype.id
      }
    }, [_vm._v(_vm._s(contacttype.name))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "for": "textinput"
    }
  }, [_vm._v("Nummer / E-Mail")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.value),
      expression: "model.model.value"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "zip",
      "required": "required"
    },
    domProps: {
      "value": (_vm.model.model.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.value = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "for": "textinput"
    }
  }, [_vm._v("Beschreibung / Anmerkung")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.description),
      expression: "model.model.description"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "zip",
      "required": "required"
    },
    domProps: {
      "value": (_vm.model.model.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.description = $event.target.value
      }
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-289d8981!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact-content.vue
// module id = 433
// module chunks = 0